export default {
  GOT_PROJECTS (state, data) {
    state.projects = data
  },
  GOT_PROJECT (state, project) {
    const { slug } = project
    state.projects[slug] = project
  },
  SELECT_PROJECT (state, slug) {
    state.currentProject = state.projects[slug]
  },

  GOT_PAGE (state, page) {
    const { post_name } = page
    state.pages[post_name] = page
  },
  SELECT_PAGE (state, slug) {
    state.currentPage = state.pages[slug]
  },

  GOT_POSTS (state, posts) {
    state.posts = posts
  },

  setIntroVisible (state, visible) {
    state.introVisible = visible
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js